import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';


export default store => ({
  path : '',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const LoginContainer = require('./containers/LoginContainer.js').default;
      const reducer = require('reducers/user').default;
      const sagas = require('sagas/sagas').default;

      injectReducer(store, { key: 'user', reducer });
      injectSagas(store, { key: 'sagas', sagas });

      cb(null, LoginContainer);
    }, 'login');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/Login/index.js